import React from 'react'
import { Spin } from 'antd'
export const Loading = () => {
  return (
    <div style={{margin: "20px 0", marginBottom:"20px", padding:"30px 50px", textAlign:"center"}}>
    <Spin />
  </div>
  )
}
